/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export class BaseValidator {
	constructor() {
	}

	name(model) {
		return "Validator"
	}

	logic(x) {
		return true;
	}

	message() {
		return "";
	}

	show(editMode) {
		return !!editMode;
	}
}